import * as React from 'react';
import { useState,useEffect } from "react";
import { useCtx } from 'one-ui-provider';
import {
  useDispatch,useSelector
} from 'react-redux';

import Row from "antd/lib/row";
import Button from "antd/lib/button";
import Col from "antd/lib/col";
import Typography from "antd/lib/typography";
import Modal from "antd/lib/modal";
import Input from "antd/lib/input";


import {
  PanvivaIdModel
} from './model';

import {
  PanvivaIdProps
} from './props';

import {
  Value,
  Values,
} from 'one-ui-values';


const { Text } = Typography;

/**
 * This function returns the Order Tab
 * @param props is a component property
 * @returns JSX code for Order Tab Card
 */
export const PanvivaIdCard = <M extends PanvivaIdModel>(
  props: PanvivaIdProps<M>
) => {
  const {
    model,
  } = props;

  const {
    panvivauserdata
  } = model || {};

  
  const { agentId,settings,ext } = useCtx();
  const { compatible } = settings;
  const { contact_center_type } = compatible;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [agentinfo, setAgentInfo] = useState("");
  const updatepanvivauserdata = useSelector((state:any) => (state.updatepanvivadata))
  const [userid, setUserId] = useState(panvivauserdata?.agentuserid);
  const dispatch = useDispatch();
  let modalUI ;
  let agentid = "";
const showModal = () => {
  setIsModalVisible(true);
  
};

const handleCancel = () => {
  setIsModalVisible(false);
};


const handleVerify = () => {

  if(contact_center_type === "finesse") {
    agentid = agentId
  dispatch({
    type: "one-state-updatepanvivaid/fetch",
    payload: {
        "panviva_user": userid,
        "finesse_user": agentid,
      "extension":ext
      }
    });
  }
  else if(contact_center_type === "five9") {
    let five9user = sessionStorage.getItem("five9_userid")
    agentid = five9user;
    dispatch({
      type:"one-state-updatepanvivaid/fetch",
      payload: {
        "panviva_user": userid,
        "five_nine_user": agentid
      
    }
  });
  }
  else if(contact_center_type === "twilio") {
    let twilio_userid =sessionStorage.getItem("twilio_userid")
    agentid = twilio_userid;
    dispatch({
      type: "one-state-updatepanvivaid/fetch",
      payload: {
        "panviva_user": userid,
        "twilio":twilio_userid
      
    }
  });
  }
  else if(contact_center_type === "vonage") {
    let vonage_userid =sessionStorage.getItem("vonage_userid")
    agentid = vonage_userid;
    dispatch({
      type: "one-state-updatepanvivaid/fetch",
      payload: {
        "panviva_user": userid,
        "vonage":vonage_userid
      
    }
  });
  }
  else if(contact_center_type === "genesys") {
    let genesys_userid =sessionStorage.getItem("agentName")
    agentid = genesys_userid;
    dispatch({
      type:"one-state-updatepanvivaid/fetch",
      payload: {
        "panviva_user": userid,
        "genesys_user": agentid
      
    }
  });
  }
  else if(contact_center_type === "inContact") {
    let inContact_userid =sessionStorage.getItem("inContact_userid");
    agentid = inContact_userid
    dispatch({
      type: "one-state-updatepanvivaid/fetch",
      payload: {
        "panviva_user": userid,
        "incontact":inContact_userid
      
    }
  });
  }
  else if(contact_center_type === "wxcc") {

    let wxccuser = sessionStorage.getItem("wxcc_userid")
    
        agentid = wxccuser;
    
        dispatch({
    
          type: "one-state-updatepanvivaid/fetch",
    
          payload: {
    
            "panviva_user": userid,
    
            "wxcc_user":wxccuser
        }
    
      });
    
      }
      else if(contact_center_type === "ringcentral") {

        let agentIdValue = sessionStorage.getItem("ringcentral_agentName")
        
            agentid = agentIdValue;
        
            dispatch({
        
              type: "one-state-updatepanvivaid/fetch",
        
              payload: {
        
                "panviva_user": userid,
        
                "ringcentral":agentIdValue
            }
        
          });
        
          }
  setAgentInfo(agentid)
   setUserId(panvivauserdata?.agentuserid)
   setIsModalVisible(false)
   sessionStorage.setItem("panvivauserinfo", userid)
    
};

useEffect(()=>{
  
  if(agentinfo){
    //Fetch Panviva User ID
    dispatch({
      type: "one-state-getpanvivaid/fetch",
      payload: {
        agentuserid: agentinfo,
            
      }
    });
 }
},[updatepanvivauserdata])

  modalUI = (
    <div>
      {props.style ?
        <Button size='default' onClick={showModal} className="agentbutton" style={props.style}>Panviva User ID</Button> :
        <Button type="primary" onClick={showModal} className="agentbutton">Panviva User ID</Button> 
      }
      <Values>
        {
          (userid) && (<Value label="Panviva User" value={userid} />)
        }
      </Values>
      <hr/>
     <Modal
     style={{ height: '230px' }}
     title={
      <div
      style={{
        marginLeft: "147px"
      }}
      >
        Change Panviva User ID
        </div>
    }
     width={575}
     visible = {isModalVisible}
     footer={[
      <Button type="primary" style={{ marginTop:"14px" }} onClick={handleCancel} >Cancel</Button>,
      <Button type="primary" style={{marginTop:"14px" }} disabled={!userid} onClick={handleVerify} >Save</Button>,
    ]}
     centered
    onCancel={handleCancel}
     >
       <Row type="flex" align="middle" gutter={[8, 8]} style={{width: '900px', marginLeft: "85px"}}>
       <Col sm={12} md={7}>
          <Row type="flex" align="middle" gutter={[4, 4]}>
            <Col span={12}>
              <Text> Panviva User ID:</Text>
            </Col>
            <Col span={6}  md={6}>
            <Input value={userid} style={{ width: "315%"}} onInput={(e) => setUserId(e.target.value)} onKeyPress={(e: React.KeyboardEvent)=>{
              //ADPAC-1829
              const specialCharRegex = /[a-zA-Z0-9_.@]/;
              const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
              if (!specialCharRegex.test(pressedKey)) {
                 e.preventDefault();
                 return false;
              }
            }} />
            </Col>
          </Row>
          
        </Col>
        
       </Row>
     </Modal>
    </div>
  )

  return (
    <div className='one-comp-getuserid'>
      {modalUI}
    </div>
  )
}
